export default Object.freeze({
  EvaluateApprovers: 1,
  HandleNotifications: 2,
  HandleAutomaticActions: 3,
  HandleOverdue: 4,
  HandleApprovalReminderNotifications: 5,
  HandleIteration: 6,
  HandleEntityOperation: 7,
  AttachmentsCopy: 8,
  HandleFinishCompleteInformationCompleted: 9,
  HandleRunCode: 10,
  HandleWaitChildRequestsReevaluate: 11,
  ReevaluateEmailTrackingEvents: 12,
  AutoSuccessEmailTrackingAfterStabilization: 13,
});
